import React from 'react'
import { Button, Progress, Icon, Popover } from 'antd'
import prettysize from '../../../../utils'
import moment from "moment"
import css                     from "classnames"

import '../styles.scss'

export default ({file, on_remove, on_error_fix }) => {
  let {name, size, type, $percent, $status, $readableSpeed, $error, $secondsLeft, bucket_name, uploaded_count, uploaded_size, status, endTime, startTime} = file
  if($status !== 'exception' && $status !== 'active'){
    $status = 'normal'
  }

  let dateLeft = new Date()
  dateLeft.setSeconds(dateLeft.getSeconds() - $secondsLeft)
  return (
  <div className='file-item columnWrap'>
    { type === 'directory' ? <Icon type="folder" /> : <Icon type="file-text"/>}

    <div>
      <span>{decodeURIComponent(name + (bucket_name ? ' → ' + bucket_name : '') )} </span>
      {
        bucket_name ?
        (
          <div>
            <Progress className={css({'hidden': type === 'directory' && status === 3 })} percent={parseFloat($percent) ? parseFloat($percent) : 0} strokeWidth={5} status={$status} showInfo={false}/>
            <span>{$secondsLeft > 0 ? ($readableSpeed.toUpperCase() + '/s - ' + prettysize(size) + ' - ' + moment(dateLeft).toNow(true) + ' left') : ''}</span>
          </div>
        ) : null
      }
      { (type === 'directory' && uploaded_count > 0) ?
        <div>
          {
            status === 3 ? ('upload completed in ' + ((endTime - startTime)/1000) + 's'):('Uploaded ' + uploaded_count + ' files with total size of ' + prettysize(uploaded_size))
          }
          </div>
        : null
      }
    </div>

    {$status === 'exception' ?
      (
        <Popover content={
          (
            <div>
              <p>Click apply to fix cors settings
                <br/>on the destination bucket</p>
              <Button onClick={() => on_error_fix(file)}>Apply</Button>
            </div>
          )
        } title={$error}>
          <Button shape="circle" icon="exclamation-circle-o" size={'small'}/>
        </Popover>
      ) : null}

    <Button shape="circle" icon="close" size={'small'} onClick={() => on_remove(file)}/>
  </div>
)}
